import ListItem from './ListItem';
import { AutoRenewal } from './types';

type Props = {
  autoRenewals: AutoRenewal[];
  autoRenewServiceName: string;
  manageUrlTemplate: string;
};

export default function List({ autoRenewals, autoRenewServiceName, manageUrlTemplate }: Props) {
  if (autoRenewals.length === 0) {
    return (
      <div className="px-5 py-14 text-center">
        <h2 className="font-semibold text-slate-900 mb-1 text-base">No subscriptions</h2>
        <div className="text-slate-600">
          We couldn&apos;t find any <span className="font-medium">{autoRenewServiceName}</span> subscriptions
          here.
        </div>
      </div>
    );
  }

  return (
    <ul className="list-none m-0 p-0">
      {autoRenewals.map((autoRenewal) => (
        // `group` is on the li rather than the anchor because the row's hover styles
        // reach the elements the anchor wraps, not the anchor itself.
        <li className="group" key={autoRenewal.id}>
          <ListItem autoRenewal={autoRenewal} manageUrlTemplate={manageUrlTemplate} />
        </li>
      ))}
    </ul>
  );
}
